// UserReducer Type Constants ---------------------------------------------------------
export const LOAD_USER = 'LOAD_USER';
export const SAVE_USER = 'SAVE_USER';
export const ADD_PILLAR = 'ADD_PILLAR';
export const EDIT_PILLAR = 'EDIT_PILLAR';
export const REMOVE_PILLAR = 'REMOVE_PILLAR';
export const ADD_SUBMISSION = 'ADD_SUBMISSION';
export const REMOVE_SUBMISSION = 'REMOVE_SUBMISSION';

// FlowReducer Type Constants
export const SET_CHECKING = 'SET_CHECKING';
export const SET_INFO_MODAL_OPEN = 'SET_INFO_MODAL_OPEN';
export const SET_ADMIN_MODAL_OPEN = 'SET_ADMIN_MODAL_OPEN';
export const SET_INTERVAL_VIEW = 'SET_INTERVAL_VIEW';
export const SET_INTERVAL_SPAN = 'SET_INTERVAL_SPAN';
